import { useEffect, useState } from "react";
import { useVisionMaxGetTokenQuery } from "../../api/network/adminApiServices";
import {
  localStorageKeys,
  useLocalStorage,
} from "../../utils/localStorageItems";

/**
 * Hook to manage VisionMax token
 * if the token is not present in local storage, it fetches a new token
 * and saves it to local storage
 * @returns VisionMax token and loading state
 */
const useVisionMax = () => {
  const [vmToken, setVmToken] = useState<string | null>();
  const { getLocalStorageItem, setLocalStorageItem } = useLocalStorage();
  const savedVmToken = getLocalStorageItem(
    localStorageKeys.camerasAdminVMToken
  );

  const {
    data: dataVisionMaxGetToken,
    isFetching: isFetchingVisionMaxGetToken,
  } = useVisionMaxGetTokenQuery({}, { skip: !!savedVmToken });

  if (!!savedVmToken && typeof savedVmToken === "string" && !vmToken) {
    setVmToken(savedVmToken);
  }
  useEffect(() => {
    if (
      !isFetchingVisionMaxGetToken &&
      !!dataVisionMaxGetToken &&
      !!dataVisionMaxGetToken.token
    ) {
      setLocalStorageItem(
        localStorageKeys.camerasAdminVMToken,
        dataVisionMaxGetToken.token
      );
      setVmToken(dataVisionMaxGetToken.token);
    }
  }, [dataVisionMaxGetToken, isFetchingVisionMaxGetToken]);

  return {
    vmToken,
    isFetchingVisionMaxGetToken,
  };
};

export default useVisionMax;
